/* PetCare — minimal shared behaviour.
   Section-specific JS lives inside each section file. */
(function () {
  'use strict';

  // Close the mobile drawer when a link inside it is used.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.pc-header__drawer a');
    if (!link) return;
    var drawer = link.closest('details');
    while (drawer) {
      drawer.open = false;
      drawer = drawer.parentElement ? drawer.parentElement.closest('details') : null;
    }
  });

  // Close the mobile drawer on Escape.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.pc-header__burger[open]').forEach(function (d) { d.open = false; });
  });
})();
